export default __webpack_public_path__ + "static/bnpl-d71eb2c018855d316f2f38d4e6fa5f15.jpg";